import * as XLSX from "xlsx";
import {saveWorkbook} from "../../../utils/excel";

const HEADER = ['名稱', '組別']

export const useExportOrganizationManagement = ({
  data,
}) => {
  // export cases detail to excel file
  const exportData = () => {
    const workbook = XLSX.utils.book_new();
    const values = []

    values.push(HEADER)
    for (const row of data){
      values.push([
        row.name,
        row.group.join(',')
      ])
    }

    const worksheet = XLSX.utils.aoa_to_sheet(values);
    XLSX.utils.book_append_sheet(workbook, worksheet, '總表');
    saveWorkbook({ workbook, fileName: '貼心到宅業務組別列表'})
  }
  return { exportData }
}